import { render, staticRenderFns } from "./Activites.vue?vue&type=template&id=1b38a090"
import script from "./Activites.vue?vue&type=script&lang=js"
export * from "./Activites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports